
class ShortVideoCarousel {
  constructor(parent) {
    this.parent = parent;
    if (!this.parent) {
      return;
    }
    this.flag = false;
    this.slideIndex = [];
    this.slider();
    this.clickEvent();
  }

  // Global slider event
  slider = () => {
    let parent = qsa('.short-video-carousel-wrapper-js');
    parent.forEach(element => {
      let swiperWrapper = qs('.short-video-swiper-js', element);
      if (!swiperWrapper) {
        return
      }
      let sectionId = element.dataset.id;
      const swiper = new Swiper(swiperWrapper, {
        effect: "coverflow",
        initialSlide: 1,
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        slidesPerView: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 70,
          modifier: 3,
          initialSlide: 2,
          slideShadows: true
        },
        navigation: {
          nextEl: `.short-video-carousel-wrapper-js.${sectionId} .swiper-button-next`,
          prevEl: `.short-video-carousel-wrapper-js.${sectionId} .swiper-button-prev`,
        },
        breakpoints: {
          990: {
            initialSlide: 2,
            slidesPerView: 3,
            coverflowEffect: {
              depth: 40,
              modifier: 10,
              initialSlide: 3
            }
          }
        }
      });
      this.playActiveSlide(swiper);
      this.slidesDataGtag(swiper, 1, 1, 1);
      swiper.on('slideChange', () => {
        this.playActiveSlide(swiper);
        this.slidesDataGtag(swiper, 1, 1, 1);
      });
    });
  }

  // Play video on active slider and pause other
  playActiveSlide = (swiper) => {
    const activeSlide = swiper.slides[swiper.activeIndex];
    let allSlides = swiper.slides;
    allSlides.forEach(element => {
      qsa('video', element).forEach(video => {
        video.pause();
      });
    });
    if (qs('.single-video', activeSlide)) {
      qs('video', activeSlide).play();
    } else {
      if (window.innerWidth < 768) {
        qs('.xs-show', activeSlide).play();
      } else {
        qs('.xs-hide', activeSlide).play();
      }
    }
  }

  // Slider gtag data
  slidesDataGtag = (swiper, mobileSlide, tabletSlide, desktopSlide) => {
    let slidesData = [];
    if (window.innerWidth < 767) {
      for (let index = 0; index < mobileSlide; index++) {
        const element = swiper.slides[swiper.activeIndex + index];
        if (!this.slideIndex.includes((swiper.activeIndex + index))) {
          this.slideIndex.push((swiper.activeIndex + index));
          let videoId = qs('.video-and-product-js', element).dataset.id;
          slidesData.push(videoId);
        }
      }
    } else if (window.innerWidth < 1024) {
      for (let index = 0; index < tabletSlide; index++) {
        const element = swiper.slides[swiper.activeIndex + index];
        if (!this.slideIndex.includes((swiper.activeIndex + index))) {
          this.slideIndex.push((swiper.activeIndex + index));
          let videoId = qs('.video-and-product-js', element).dataset.id;
          slidesData.push(videoId);
        }
      }
    } else {
      for (let index = 0; index < desktopSlide; index++) {
        const element = swiper.slides[swiper.activeIndex + index];
        if (!this.slideIndex.includes((swiper.activeIndex + index))) {
          this.slideIndex.push((swiper.activeIndex + index));
          let videoId = qs('.video-and-product-js', element).dataset.id;
          slidesData.push(videoId);
        }
      }
    }
    console.log("slidesData", slidesData);
    dataLayer.push({'event':'video_play','video_id':slidesData});
  }

  // General click event
  clickEvent = () => {
    let parent = qsa('.short-video-carousel-wrapper-js');
    parent.forEach(element => {

      // Global slider click event
      let wrapper = qsa('.video-and-product-js', element);
      wrapper.forEach(ele => {
        ele.addEventListener('click', (e) => {
          let that = e.currentTarget;
          let videoId = that.dataset.id;
          console.log("Slide click event", videoId);
          dataLayer.push({'event':'video_click','video_id':videoId});

          let slide = that.closest('.swiper-slide');
          let activeIndex = slide.dataset.swiperSlideIndex;
          let sectionWrapper = that.closest('.shopify-section');
          let popupWrapper = qs('.reel-video-popup-wrapper', sectionWrapper);
          document.body.style.overflow = "hidden";
          popupWrapper.classList.add('active');
          let popupSwiper = qs('.swiper', popupWrapper);
          qs('.loader', popupWrapper).classList.add('hide');
          qs('.reel-video-popup-inner', popupWrapper).classList.remove('hide');
          qs('.reel-video-popup-inner', popupWrapper).classList.add('reel-slides');
          const swiper = new Swiper(popupSwiper, {
            speed: 400,
            spaceBetween: 0,
            slidesPerView: 1,
            grabCursor:false,
            loop: true,
            initialSlide: parseInt(activeIndex),
            allowTouchMove: false,navigation: {
              nextEl: '.swiper-button-next.reel-next',
              prevEl: '.swiper-button-prev.reel-prev',
            },
          });
          // swiper.slideTo(parseInt(activeIndex));
          this.playActiveSlide(swiper);
          swiper.on('slideChange', () => {
            this.playActiveSlide(swiper);
          });
          this.popupEvent(popupWrapper, true);


          // let productHandle = that.dataset.product;
          // let video = that.dataset.video;
          // let poster = that.dataset.poster;
          // let productUrl = `/products/${productHandle}?section_id=reel-video-popup`
          // if (video != '') {
          //   let date = new Date().getTime();
          //   productUrl = `/products/${productHandle}?section_id=reel-video-popup&date=${date}&video_url=${video}`;
          // }
          // this.fetchPopupData(productUrl, that, poster, video);
        })
      });

      // popup close event
      let popupClose = qs('.reel-video-close-wrapper', element);
      popupClose?.addEventListener('click', (e) => {
        let that = e.currentTarget;
        let wrapper = that.closest('.reel-video-popup-wrapper');
        if (wrapper) {
          wrapper.classList.remove('active');
          qs('.loader', wrapper).classList.remove('hide');
          qs('.reel-video-popup-inner', wrapper).classList.add('hide');
          qs('.reel-video-popup-inner', wrapper).classList.remove('reel-slides');
          document.body.style.overflow = "auto";
        }
      });

      // Product page video click event
      let video = qs('.reel-video', element);
      video?.addEventListener('click', (e) => {
        let that = e.currentTarget;
        let sectionWrapper = that.closest('.short-video-carousel-wrapper-js');
        let productHandle = sectionWrapper.dataset.product;
        let video = sectionWrapper.dataset.video;
        let poster = sectionWrapper.dataset.poster;
        let productUrl = `/products/${productHandle}?section_id=reel-video-popup`
        if (video != '') {
          let date = new Date().getTime();
          productUrl = `/products/${productHandle}?section_id=reel-video-popup&date=${date}&video_url=${video}`;
        }
        this.fetchPopupData(productUrl, that, poster, video);
        let reelWrapper = qs('.reel-video-wrapper', sectionWrapper);
        reelWrapper.classList.add('hide')
      });

      // Product page unmute button click
      let productUnmute = qs('.video-unmute-wrapper-js', element);
      productUnmute?.addEventListener('click', (e) => {
        let that = e.currentTarget;
        let sectionWrapper = that.closest('.short-video-carousel-wrapper-js');
        let productHandle = sectionWrapper.dataset.product;
        let video = sectionWrapper.dataset.video;
        let poster = sectionWrapper.dataset.poster;
        let productUrl = `/products/${productHandle}?section_id=reel-video-popup`
        if (video != '') {
          let date = new Date().getTime();
          productUrl = `/products/${productHandle}?section_id=reel-video-popup&date=${date}&video_url=${video}`;
        }
        this.fetchPopupData(productUrl, that, poster, video);
        let reelWrapper = qs('.reel-video-wrapper', sectionWrapper);
        reelWrapper.classList.add('hide')
      });

      // product page video close event
      let videoClose = qs('.small-reel-video-close-js', element);
      videoClose?.addEventListener('click', (e) => {
        let that = e.currentTarget;
        let sectionWrapper = that.closest('.short-video-carousel-wrapper-js');
        sectionWrapper.classList.add('hide');
      });
    });
  }


  // Fetch video and product popup data
  fetchPopupData = (url, that, poster, video) => {
    let sectionWrapper = that.closest('.shopify-section');
    let popupWrapper = qs('.reel-video-popup-wrapper', sectionWrapper);
    document.body.style.overflow = "hidden";
    popupWrapper.classList.add('active');
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        let responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        if (sectionWrapper) {
          let productDetails = qs('.reel-video-popup-content', responseHTML);
          qs('.reel-video-popup-content', popupWrapper).innerHTML = "";
          qs('.reel-video-popup-content', popupWrapper).innerHTML = productDetails.innerHTML;
          qs('video', popupWrapper).setAttribute('poster',poster);
          if (video) {
            qs('video source', popupWrapper).setAttribute('src', video);
          }
          qs('.loader', popupWrapper).classList.add('hide');
          qs('.reel-video-popup-inner', popupWrapper).classList.remove('hide');
          this.popupEvent(popupWrapper);
        }
      })
  }

  // popup reinit event
  popupEvent = (data, flag = false) => {
    if (!data) {
      return;
    }
    if (flag) {
      if (this.flag) {
        return;
      }
      this.flag = true;
      let popupWrapper = data;
      let parents = qsa('.video-product-wrapper', popupWrapper);
      parents.forEach(parent => {
        this.productSlider(parent);
        this.productChangeEvent(parent);
        this.productAddToCart(parent);
        this.popupClickEvent(parent);
      });
    } else {
      let parent = data
      this.productSlider(parent);
      this.productChangeEvent(parent);
      this.productAddToCart(parent);
      this.popupClickEvent(parent);
    }
  }

  // popup click event
  popupClickEvent = (parent) => {
    let soundIcon = qs('.volume-sound-icon', parent);

    // Mute/Unmute click event
    soundIcon?.addEventListener('click', (e) => {
      let that = e.currentTarget;
      let videoWrapper = that.closest('.video-wrapper');
      let video = qs('video', videoWrapper);
      video.muted ? video.muted = false : video.muted = true;
      let icons = qsa('.volume-icon', that);
      icons.forEach(icon => {
        icon.classList.add('hide');
      });
      video.muted ? qs(".sound-off", that).classList.remove('hide') : qs(".sound-on", that).classList.remove('hide');
    });

    // Mobile product open click
    let productOpenBtn = qs('.open-product-js', parent);
    productOpenBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      let that = e.currentTarget;
      this.productOpenClose(that);
    });

    // Background click
    let bgDiv = qs('.bg-transparent-js', parent);
    bgDiv?.addEventListener('click', (e) => {
      let that = e.currentTarget;
      this.productOpenClose(that, false);
    });

    // Arrow down click event
    let arrowDown = qs('.arrow-down-wrapper-js', parent);
    arrowDown?.addEventListener('click', (e) => {
      let that = e.currentTarget;
      this.productOpenClose(that, false);
    });
  }

  // Product page product popup open/close event
  productOpenClose = (that,data = true) => {
    if (data) {
      let wrapper = that.closest('.video-product-wrapper');
      let productWrapper = qs('.product-detail-wrapper', wrapper);
      let background = qs('.bg-transparent-js', wrapper);
      background.classList.add('active');
      productWrapper.classList.add('active');
    } else {
      let wrapper = that.closest('.video-product-wrapper');
      let productWrapper = qs('.product-detail-wrapper', wrapper);
      let background = qs('.bg-transparent-js', wrapper);
      background.classList.remove('active');
      productWrapper.classList.remove('active');
    }
  }

  // popup add to cart click event
  productAddToCart = (parent) => {
    let addToCartBtn = qs('.product-card-atc-js', parent);
    addToCartBtn?.addEventListener('click', async (e) => {
      e.preventDefault();
      let that = e.currentTarget;
      //check input quantity for atc
      let atcBtn = that;
      let vId = atcBtn.getAttribute('data-vid');
      let pId = atcBtn.getAttribute('data-pid');
      if(atcBtn?.classList.contains('limit-tag-exist') && simply.enable_product_quantity && simply.product_quantity_limit != 0) {
        //call this fuction to check cart product qty.
        const result = await checkCartData(pId,false);
        if (!result) {
          console.log("ID match found, stopping further processing.");
          return false;
        } else {
          console.log("No matching ID found, continue with further processing.");
        }
      }
      that.classList.add('btn-loading');
      let value = parseInt(vId);
      // gtag for product added
      console.log("Product add to cart", value);
      dataLayer.push({'event':'video_product_added','variant_id':value});
      let formData = {
        'items': [{
          'id': value,
          'quantity': 1
        }]
      };
      let checkout = null;
      let sectionWrapper = that.closest('.short-video-carousel-wrapper-js');
      if (sectionWrapper) {
        checkout = sectionWrapper.dataset.checkout;
      }

      // gokwik checkout
      if (checkout == "gokwik") {
        fetch(`/cart/clear.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => response.json())
        .then(data => {
          window.addToCartFun(formData, () => {
            that.classList.remove('btn-loading');
            let wrapper = that.closest('.reel-video-popup-wrapper');
            if (wrapper) {
              wrapper.classList.remove('active');
            }
            window.initiateGokwik();
          }); 
        })
      } else {
        // shopify checkout
        window.addToCartFun(formData, () => {
          that.classList.remove('btn-loading');
          if (checkout == "sidecart") {
            let wrapper = that.closest('.reel-video-popup-wrapper');
            if (wrapper) {
              wrapper.classList.remove('active');
            }
            window.dispatchCartJson();
            window.openSideCartFlag();
          } else if (checkout == "toast") {
            toastMessage({ msg: `Product added` });
          }
        });
      }
    });
  }

  // popup product change event
  productChangeEvent = (parent) => {
    if (qs("variant-radios input", parent)) {
      qsa("variant-radios input", parent).forEach(item => {
        item.addEventListener('change', (e) => {
          
          qsa('variant-radios input',parent).forEach(option => {
            option.closest('.option-list').classList.remove('selected')
          });
          qsa('variant-radios input:checked', parent).forEach(option => {
            option.closest('.option-list').classList.add('selected')
          });
          let addToCartBtn = qs('.product-card-atc-js', parent);
          let isVariantAvailable = false;
          if(item.getAttribute("is-available") == "true") {
            isVariantAvailable = true;
          }
          let price = item.getAttribute('data-price');
          addToCartBtn.setAttribute('data-price', price);
          let vId = item.getAttribute('id');
          addToCartBtn.setAttribute('data-vid', vId);
          let title = item.dataset.title;
          let sliders = qsa('.slider-section', parent);
          if (sliders.length > 1) {
            sliders.forEach(slide => {
              slide.classList.remove('active');
            });
            qs(`.slider-section[data-id="${title}"]`, parent) ? qs(`.slider-section[data-id="${title}"]`, parent).classList.add('active') : null;
          }
          if(isVariantAvailable) {
            addToCartBtn.removeAttribute('disabled');
            addToCartBtn.innerText = "ADD TO CART";
          }
          else {
            addToCartBtn.setAttribute('disabled', '');
            addToCartBtn.innerText =  "SOLD OUT";
          }
        })
      })
    }
  }
  

  // popup product slider
  productSlider = (parent) => {
    let imageSlider = qsa('.product-images-swiper-js', parent);
    imageSlider.forEach(element => {
      new Swiper(element, {
        loop: true,
        slidesPerView: 1.6,
        spaceBetween: 10,
        // initialSlide: 1,
        centeredSlides: true,
        grabCursor:false,
        breakpoints: {
          767: {
            slidesPerView: 2
          }
        }
      });
    });
  }
}

new ShortVideoCarousel(qs('.short-video-carousel-wrapper-js'));
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    new ShortVideoCarousel(qs('.short-video-carousel-wrapper-js'));
  });
}